/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card1_TitleInputs */

const tr_landing_web_card1_title = /** @type {(inputs: Landing_Web_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürükle bırak düzenleyici`)
};

const en_landing_web_card1_title = /** @type {(inputs: Landing_Web_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag and drop builder`)
};

const de_landing_web_card1_title = /** @type {(inputs: Landing_Web_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baukasten zum Ziehen und Ablegen`)
};

const ru_landing_web_card1_title = /** @type {(inputs: Landing_Web_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конструктор перетаскиванием`)
};

/**
* | output |
* | --- |
* | "Drag and drop builder" |
*
* @param {Landing_Web_Card1_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card1_title = /** @type {((inputs?: Landing_Web_Card1_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card1_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card1_title(inputs)
	if (locale === "de") return de_landing_web_card1_title(inputs)
	if (locale === "ru") return ru_landing_web_card1_title(inputs)
	return tr_landing_web_card1_title(inputs)
});